import { ACTIONS } from "../../enums/actions"
import { genericAction } from "./genericAction"

export const uploadWageWorksheet = genericAction(ACTIONS.UPLOAD_WAGE_WORKSHEET);